




















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'scroll-top'
})
export default class ScrollTop extends Vue {
  @Prop()
  private toId!: string;
  @Prop()
  private elId!: string;

  private showBtn: boolean = false;
  private scrollEl!: HTMLElement;

  mounted(): void {
    this.scrollEl = document.getElementById(this.elId) as HTMLElement;
    this.scrollEl.addEventListener('scroll', this.onScroll);
  }

  destroyed(): void {
    this.scrollEl.removeEventListener('scroll', this.onScroll);
  }

  onScroll(): void {
    this.showBtn = this.scrollEl.scrollTop > 500;
  }
}
